interface NamedUser {
  full_name: string;
}

export interface MentionSegment {
  text: string;
  mention: boolean;
}

export const segmentMentions = (body: string, users: NamedUser[]): MentionSegment[] => {
  if (!users.length) return body ? [{ text: body, mention: false }] : [];

  const escapedNames = users.map((user) => user.full_name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const mentionPattern = new RegExp(`@(?:${escapedNames.join("|")})`, "g");
  const segments: MentionSegment[] = [];
  let lastIndex = 0;
  let match;
  while ((match = mentionPattern.exec(body)) !== null) {
    if (match.index > lastIndex) segments.push({ text: body.slice(lastIndex, match.index), mention: false });
    segments.push({ text: match[0], mention: true });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < body.length) segments.push({ text: body.slice(lastIndex), mention: false });
  return segments;
};
